const mutations = {
  SET_KEYPAD_NEXT_BUTTON_TABLE_BUBBLE: (state, value) => {
    state.keypadNextButtonTableBubble = value;
  },

  NEXT_CELL_BUBBLE_TABLE: (state, payload) => {
    state.nextTableBubbleCellIndex = payload;
  },
  SET_CURRENT_MEASURMENT_TABLE_CELL: (state, payload) => {
    state.currentMeasurmentTableCell = payload;
  },
};

export default mutations;
